/**
 * 이 파일은 Aui 의 일부입니다. (https://aui.moimz.tools)
 *
 * 툴바 구분자를 정의한다.
 *
 * @file /src/rootin/tools/separator/Separator.ts
 * @author Arzz <arzz@arzz.com>
 * @license MIT License
 * @modified 2026. 7. 17.
 */
import { Tool } from '@rootin/base/Tool';
import { Dom } from '@utils/Dom';
import { Html } from '@utils/Html';

export class Separator extends Tool {
    /**
     * 툴타입
     */
    static type: string = 'separator';

    /**
     * 툴그룹
     */
    static group: string = 'separator';

    /**
     * 툴아이콘
     */
    icon: string = '';

    /**
     * 구분자 DOM 을 가져온다. 버튼 없이 구분선 하나만 있는 DOM 이다.
     *
     * @returns 구분자 DOM
     */
    $getContainer(): Dom {
        if (this.$container === null) {
            this.$container = Html.create('div', { 'data-role': 'separator' });
        }

        return this.$container;
    }

    /**
     * 구분자는 버튼이 없으므로 렌더링할 것이 없다.
     */
    async render(): Promise<void> {}

    /**
     * 구분자는 클릭 핸들러가 없다.
     */
    handler(): void {}

    /**
     * 구분자는 스스로 표시여부를 갱신하지 않는다.
     */
    refresh(): void {}

    /**
     * 구분자의 표시여부를 지정한다.
     *
     * @param visible - 표시여부
     */
    setVisible(visible: boolean): void {
        this.$getContainer().toggleClass('hidden', visible === false);
    }
}
